<footer class="footer">
  <div class="container">
    <div class="footer__content">
      <div class="footer__logo">
        <span class="footer__logo-text">Zapphira.ai</span>
        <p class="footer__tagline">Transformando la comunicación digital</p>
      </div>
      <div class="footer__links">
        <div class="footer__links-column">
          <h3 class="footer__links-title">Producto</h3>
          <ul class="footer__links-list">
            <li><a href="#">Funcionalidades</a></li>
            <li><a href="#">Precios</a></li>
            <li><a href="#">Demo</a></li>
            <li><a href="#">Casos de uso</a></li>
          </ul>
        </div>
        <div class="footer__links-column">
          <h3 class="footer__links-title">Empresa</h3>
          <ul class="footer__links-list">
            <li><a href="#">Sobre nosotros</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Contacto</a></li>
            <li><a href="#">Trabaja con nosotros</a></li>
          </ul>
        </div>
        <div class="footer__links-column">
          <h3 class="footer__links-title">Legal</h3>
          <ul class="footer__links-list">
            <li><a href="#">Términos de servicio</a></li>
            <li><a href="#">Política de privacidad</a></li>
            <li><a href="#">Cookies</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <p class="footer__copyright">
        © {{ currentYear }} Zapphira.ai. Todos los derechos reservados.
      </p>
      <div class="footer__social">
        <a href="#" class="footer__social-link">LinkedIn</a>
        <a href="#" class="footer__social-link">Twitter</a>
        <a href="#" class="footer__social-link">Instagram</a>
      </div>
    </div>
  </div>
</footer>
